import {Component} from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {MatIcon} from "@angular/material/icon";
import {CdkCopyToClipboard} from "@angular/cdk/clipboard";

@Component({
  selector: 'app-copy-value',
  standalone: true,
  templateUrl: './copy-value.component.html',
  imports: [
    MatIcon,
    CdkCopyToClipboard
  ],
  styleUrls: ['./copy-value.component.scss']
})
export class CopyValueComponent implements ICellRendererAngularComp {

  public valueToCopy!: any;

  constructor() {
  }

  agInit(params: ICellRendererParams): void {
    this.valueToCopy = params.value;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }
}
